import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HeaderService } from 'src/app/components/header/header.service';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { PriceyardService } from 'src/app/modules/priceyard/services/priceyard.service';

@Component({
  selector: 'app-seller-cell-renderer',
  templateUrl: './seller-cell-renderer.component.html',
  styleUrls: ['./seller-cell-renderer.component.scss']
})
export class SellerCellRendererComponent implements OnInit {
  params: any;
  selectedAccountType;
  isEdit: boolean = false;
  constructor(private headerService: HeaderService,
    private priceyardService: PriceyardService,
    private snackbar: MatSnackBar) {
    this.headerService.accountSelectedType.subscribe((e) => {
      this.selectedAccountType = e[0].toLocaleLowerCase();
    });
  }
  agInit(params: any): void {
    this.params = params;
  }

  ngOnInit(): void {}

  focusOut(){
    this.isEdit= false;
    const payload = {
      amazonId: this.params.data.SellerId,
      name: this.params.data.Seller
    }
    this.priceyardService.SaveSellersName(payload).subscribe((res) => {
      this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Changes Saved Successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
    });
  }

  editSellerName(){
    this.isEdit= true;
  }

}